import {
  GET_COMMENTS_REQUEST,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAILURE,
  ADD_COMMENT_REQUEST,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILURE
} from './commentTypes';

/**
 * Estado inicial del reducer de comentarios
 * @type {Object}
 * @property {Object} comments - Objeto que mapea ticketId -> array de comentarios
 * @property {boolean} loading - Indica si hay una operación en curso
 * @property {null|string} error - Mensaje de error si existe
 */
const initialState = {
  comments: {}, // Objeto que mapea ticketId -> array de comentarios
  loading: false,
  error: null
};

/**
 * Reducer para gestionar el estado de los comentarios de tickets
 * Implementa el patrón de responsabilidad única manejando solo operaciones relacionadas con comentarios
 * 
 * @param {Object} state - Estado actual del reducer
 * @param {Object} action - Acción a procesar con type y payload
 * @returns {Object} Nuevo estado
 */
const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Casos para obtener comentarios
    case GET_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_COMMENTS_SUCCESS:
      return {
        ...state,
        comments: {
          ...state.comments,
          [action.payload.ticketId]: action.payload.comments
        },
        loading: false
      };

    case GET_COMMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    // Casos para agregar comentarios
    case ADD_COMMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ADD_COMMENT_SUCCESS:
      const { ticketId, comment } = action.payload;
      const ticketComments = state.comments[ticketId] || [];

      return {
        ...state,
        comments: {
          ...state.comments,
          [ticketId]: [...ticketComments, comment]
        },
        loading: false
      };

    case ADD_COMMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    default:
      return state;
  }
};

export default commentReducer;
